export const GBPE_NAMESPACE = 'GBPE_API_CACHE_'

export enum UserInfoItems {
	profile = 'profile',
	vehicles = 'vehicles',
	rewards = 'rewards',
	missingInfo = 'missingInfo',
	notifications = 'notifications',
	cart = 'cart',
	koreaProfileRefresh = 'koreaProfileRefresh',
	koreaCheckJson = 'koreaCheckJson',
}

export interface MissingInfoKeys {
	url: string
	priority: number
	requiredAttribute: boolean
	completed: string
}

export interface ProfileKeys {
	login_id: string
	email_address: string
	status: string
	initial: string
	first_name: string
	last_name: string
	profile_id: string
}

export interface RewardsKeys {
	status: string
	points: string
	tier: string
	RespCode: string
}

export const RewardsStatus = ['open', 'suspended', 'closed', 'active', '200']

export enum RewardsState {
	active = 'open',
	closed = 'closed',
	inactive = 'inactive',
	other = 'other',
}

export interface VehicleKeys {
	imgUrl: string
	link: string
	title: string
}

export interface NotificationKeys {
	notificationOn: boolean
	unreadCount: number
}

export interface AuthUserData {
	profile: ProfileKeys
	profileFallback?: boolean
	profileLoading?: boolean
	rewards: RewardsKeys
	vehicles: VehicleKeys[]
	missingInfo: MissingInfoKeys
	notification: NotificationKeys
}

export interface CartKeys {
	itemCount: number
}
